/* eslint-disable max-len */
import { makeStyles } from '@mui/styles';
import Container from 'components/Container/Container';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'components/Img/perfumes.jpg' o... Remove this comment to see the full error message
import BgSvg from 'components/Img/perfumes.jpg';
import config from 'config';
import { memo } from 'react';
import { Helmet } from 'react-helmet-async';

import { Grid, Paper, Typography, Divider } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

const useStyles = makeStyles(
  (theme) => ({
    '@keyframes peaceicon': {
      '0%': {
        animationTimingFunction: 'ease-in, ease-in-out',
        transform: 'matrix(1,0,0,1,3,8)',
      },
      '50%': {
        animationTimingFunction: 'ease-in, ease-in-out',
        transform: 'matrix(1,0,0,1,3,17)',
      },
      '100%': {
        animationTimingFunction: 'ease-in, ease-in-out',
        transform: 'matrix(1,0,0,1,3,8)',
      },
    },
    bgCont: {
      display: 'flex',
      color: '#fff',
      minHeight: 800,
      width: 'calc(100% + 2px)',
      position: 'relative',
      overflow: 'hidden',
    },
    bg: {
      display: 'flex',
      color: '#fff',
      backgroundImage: `url(${BgSvg})`,
      fallbacks: [
        {
          backgroundImage: 'linear-gradient(-30deg, #00004d 0%, #5333ed 49%, #2cd4d9 100%)',
        },
      ],
      minHeight: 800,
      width: 'calc(100% + 2px)',
      backgroundSize: 'cover',
      backgroundPosition: 'top center',
      position: 'absolute',
      transform: 'scale(1.3)',
      top: -120,
      left: 100,
    },
    bgOpacity: {
      backgroundColor: '#000',
      opacity: 0.3,
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
    bgContainerUp: {
      position: 'relative',
      display: 'flex',
      width: '100%',
    },
    container100: {
      height: '100%',
    },
    containerFeatures: {
      paddingTop: 50,
      zIndex: 99,
      position: 'relative',
      top: -25,
      '&:after': {
        height: 72,
        width: '100%',
        position: 'absolute',
        zIndex: -1,
        bottom: 0,
        content: '" "',
        display: 'block',
        backgroundImage:
          "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' viewBox='0 0 100 100'><polygon fill='#fff' points='0,40 0,100 100,100 0,0' /></svg>\")",
        backgroundRepeat: 'no-repeat',
      },
    },
    paperFeatures: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(10),
    },
    typoWithIcon: {
      display: 'inline-flex',
    },
    iconsWithText: {
      fontSize: 28,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      marginRight: theme.spacing(3),
    },
    containerSecond: {
      position: 'relative',
      bottom: -120,
    },
    containerContentSecond: {},
    peaceicon: {
      '& g > g > g > g:nth-child(2)': {
        animationName: '$peaceicon',
        animationDuration: '3s',
        animationIterationCount: 'infinite',
      },
    },
    paper: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(5),
    },
    paperNorrmal: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(5),
    },
    iconBox: {
      fontSize: 70,
      marginBottom: 40,
    },
    containerOver: {
      position: 'relative',
      top: -220,
    },
  }),
  { name: 'BringerPerfumes' }
);

const Home = memo(
  () => {
    const classes = useStyles();
    const title = 'Bringer Parcel Xpress';
    // eslint-disable-next-line
    const description =
      'Ship anywhere in the world with a click. Our online tools let you ship with confidence without downloading software';

    const { t } = useTranslation();

    const ldjson = {
      '@context': 'http://schema.org',
      '@type': 'WebSite',
      url: config.domain,
      name: config.app.title,
      alternateName: 'Bringer',
      image: `${config.domain}/bpx-logo-white.png`,
      sameAs: [
        'https://www.facebook.com/Bringer',
        'https://instagram.com/Bringer',
        'https://www.linkedin.com/company/Bringer/',
        'https://twitter.com/@Bringer',
      ],
    };

    const ldjsonOrg = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: config.app.title,
      legalName: 'Bringer CORP',
      email: `mailto:contact@${config.host}`,
      url: config.domain,
      logo: `${config.domain}/bpx-logo-white.png`,
      sameAs: [
        'https://www.facebook.com/Bringer',
        'https://instagram.com/Bringer',
        'https://www.linkedin.com/company/Bringer/',
        'https://twitter.com/@Bringer',
      ],
    };

    return (
      <>
        <Helmet>
          <title>{title}</title>
          <link rel="canonical" href={`${config.domain}/`} />
          <meta name="description" content={description} />
          <meta property="og:title" content={title} />
          <meta property="twitter:title" content={title} />
          <meta name="og:description" content={description} />
          <meta name="twitter:description" content={description} />
          <meta property="og:type" content="website" />
          <meta name="robots" content="index, follow" />
          <script type="application/ld+json">{JSON.stringify(ldjson)}</script>
          <script type="application/ld+json">{JSON.stringify(ldjsonOrg)}</script>
        </Helmet>
        <div className={classes.bgCont}>
          <div className={classes.bg} />
          <div className={classes.bgOpacity} />
          <div className={classes.bgContainerUp}>
            <Container>
              <Grid container alignItems="center" className={classes.container100}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="h2" component="h1" color="inherit" gutterBottom>
                    {t('public.perfumes')}
                  </Typography>
                </Grid>
              </Grid>
            </Container>
          </div>
        </div>
        <div className={classes.containerFeatures}>
          <Container className={classes.containerOver}>
            <Grid container className={classes.containerSecond}>
              <Grid item xs={12}>
                <Grid container spacing={2} justifyContent="space-between">
                  <Grid item xs={12} sm={12} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <Typography variant="h4">{t('public.perfumes.1')}</Typography>
                      <Typography>{t('public.perfumes.2')}</Typography>
                      <br />
                      <Divider />
                      <br />
                      <Typography variant="h4">{t('public.perfumes.3')}</Typography>
                      <Typography>{t('public.perfumes.4')}</Typography>
                      <Typography>
                        {t('public.perfumes.5')}
                        <span>(https://www.iata.org/publications/dgr/</span>
                        <span>Pages/index.aspx)</span>.
                      </Typography>
                      <br />
                      <Divider />
                      <br />
                      <Typography variant="h4">{t('public.perfumes.6')}</Typography>
                      <Typography>{t('public.perfumes.7')}</Typography>

                      <a href="mailto:support@bringer.com">
                        <strong>{t('public.perfumes.8')}</strong>
                      </a>
                      <br />
                      <br />
                      <Divider />
                      <br />
                      <Typography variant="h4">{t('public.perfumes.9')}</Typography>
                      <Typography>{t('public.perfumes.10')}</Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </div>
      </>
    );
  },
  () => true
);

export default Home;
